module.exports = __webpack_public_path__ + "static/media/backbase-live.cf09420c.jpeg";